import { useDispatch } from "react-redux"
import styled from "styled-components"
import { handleActiveSelect } from "../../features/layout/layoutSlice"
import { useSelector } from "react-redux"
import { sendRegularWeeklyNotification, setWeekDayItem } from "../../features/admin4/admin4Slice"
import TimeInput from "../shared/input/notification/TimeInput"
import Btn from "../shared/button/Btn"
import getNextWeekSameDayAndTime from "../../helper/notification/getNextWeekSameDayAndTime"
import SmallSpinner from "../shared/spinners/SmallSpinner"

const Container = styled.div`
    width: auto;
    display: flex;
    flex-direction: column;

    .week-day-container{
        position: relative;
        width: auto;
        height: auto;
        margin-bottom: 10px;

        .week-day-selected{
            width: 362px;
            height: 40px;
            border: 1px solid ${({theme}) => theme.mainBorderColor};
            cursor: pointer;
            font-size: var(--font-size-sm);
            font-weight: var(--font-weight-md);
            display: flex;
            justify-content: flex-start;
            align-items: center;
            padding-left: 15px;
            border-top-right-radius: 5px;
            border-top-left-radius: 5px;
        }
        
        .week-day-list{
            position: absolute;
            top: 40px;
            display: flex;
            flex-direction: column;
            width: 362px;
            gap: 10px;
            background-color: ${({theme}) => theme.mainBgColor};
            border: 1px solid ${({theme}) => theme.mainBorderColor};
            border-top: none;
            padding: 10px;
            border-bottom-right-radius: 5px;
            border-bottom-left-radius: 5px;
            z-index: 10;
            gap: 5px;

            .week-day-item{
                width: 100%;
                height: 40px;
                background-color: ${({theme}) => theme.secondaryBgColor};
                border-radius: 5px;
                display: flex;
                justify-content: center;
                align-items: center;
                cursor: pointer;
                border: 1px solid transparent;
                font-weight: var(--font-weight-md);

                &:hover{
                    border-color: ${({theme}) => theme.mainTextColor};
                }
            }

            .active{
                background-color: var(--color-main);
                color: #fff;
            }
        }
    }

    .checkbox-container{
        margin-bottom: 20px;
    }

    .time-container{
        position: relative;
        width: 250px;
        height: 40px;
        margin-top: 10px;
        margin-bottom: 20px;
        
    }

`

const weekList = [
    {
        id: 1,
        text: "Pazartesi"
    },
    {
        id: 2,
        text: "Salı"
    },
    {
        id: 3,
        text: "Çarşamba"
    },
    {
        id: 4,
        text: "Perşembe"
    },
    {
        id: 5,
        text: "Cuma"
    },
    {
        id: 6,
        text: "Cumartesi"
    },
    {
        id: 0,
        text: "Pazar"
    },
]

const RegularWeekSelectContainer = ({isAll}) => {

    const dispatch = useDispatch()

    const {
        weekDayItem,
        selectedPhoneNumbers,
        timeData,
        notificationMenu,
        notificationSubMenu,
        notificationText,
        notificationTitle,
        mobileNotification,
        isLoadingSendRegularWeeklyNotification,
        } = useSelector(state => state.admin4)

    const {
        activeSelect
    } = useSelector(state => state.layout)

    const handleClick = () => {

        if(!isAll){
            if(timeData.minute && timeData.hour && weekDayItem.id && notificationMenu.value && selectedPhoneNumbers.length > 0 && notificationTitle && notificationText){
            
                const body = {
                    scheduledTime: getNextWeekSameDayAndTime({dayOfWeek:weekDayItem?.id, hour: timeData.hour, minute: timeData.minute}),
                    isRegular: true,
                    isRegularType: 1,
                    isEveryone: false,
                    isMobileUser:true,
                    title: notificationTitle,
                    text:  notificationText,
                    weeklyDayId:  weekDayItem?.id,
                    screenName: notificationSubMenu.value,
                    routeName:notificationMenu.value,
                    notificationAdded: mobileNotification,
                    scheduledNotificationRecipients: selectedPhoneNumbers.map(item => {
                        return {
                            phoneNumber: item.phoneNumber
                        }
                    })
                }
    
                dispatch(sendRegularWeeklyNotification(body))
                
            }
        }

        else{
            if(timeData.minute && timeData.hour && weekDayItem.id && notificationMenu.value && notificationTitle && notificationText){
            
                const body = {
                    scheduledTime: getNextWeekSameDayAndTime({dayOfWeek:weekDayItem?.id, hour: timeData.hour, minute: timeData.minute}),
                    isRegular: true,
                    isRegularType: 1,
                    isEveryone: true,
                    isMobileUser:true,
                    title: notificationTitle,
                    text:  notificationText,
                    weeklyDayId:  weekDayItem?.id,
                    screenName: notificationSubMenu.value,
                    routeName:notificationMenu.value,
                    notificationAdded: mobileNotification,
                }
    
                dispatch(sendRegularWeeklyNotification(body))
                
            }
        }
        
       
    }

  return (
    <Container>
        <div className="week-day-container">
            <div className="week-day-selected" onClick={() => dispatch(handleActiveSelect((activeSelect && activeSelect === "week-day-selected") ? null : "week-day-selected"))}>{weekDayItem.id ? `Her haftanın ${weekDayItem.text} günü bildirim gönderilecek` : "Haftanın hangi günü olduğunu seçiniz"}</div>
            {
                activeSelect === "week-day-selected" &&
                <div className="week-day-list">
                    {
                        weekList.map((item) => (
                            <div key={item.id} className={weekDayItem.id === item.id ? "active week-day-item" : "week-day-item"} onClick={() => dispatch(setWeekDayItem(item))}>{item.text}</div>
                        ))
                    }
                </div>
            }
        </div>

        <div className="time-container">
            <TimeInput inputWidth={"250px"}/>
        </div>

        <Btn bgColor="var(--color-main)" color="#fff" handleClick={handleClick} width={"250px"}>{isLoadingSendRegularWeeklyNotification ? <SmallSpinner size={"10px"} color={"#fff"} bgColor={"#E85446"}/> : "Bildirim Gönder"}</Btn>
    </Container>
  )
}

export default RegularWeekSelectContainer